import { useEffect, useState } from 'react';
import { highlightOddChange } from '../sport-effects';

export function useHighlightOddChange(oddContainer, value, enabled) {
    const [, setOddValue] = useState(value);
    useEffect(() => {
        if (!enabled) {
            return;
        }
        const classList = oddContainer.current?.classList;
        setOddValue(prev => {
            highlightOddChange(prev, value, classList);
            return value;
        });
    }, [oddContainer, value, enabled]);
}
